import React from 'react';
import { Button } from '@mui/material';
import Screen from '../Screen';
import Form from '../Form';
import ButtonPrimary from '../ButtonPrimary';
import useForm from './useForm';
import InputBankRoutingNumber from '../InputBankRoutingNumber';
import InputBankAccountNumber from '../InputBankAccountNumber';
import InputBankName from '../InputBankName';
import InputBankAccountType from '../InputBankAccountType';

const AddBankAccount = ({ onDone }) => {
  const {
    handleSubmit,
    isLoading,
    form,
  } = useForm({ onDone });

  return (
    <Screen header="Add a new bank account.">
      <Form
        form={form}
        onSubmit={handleSubmit}
      >
        <InputBankRoutingNumber />
        <InputBankAccountNumber />
        <InputBankName />
        <InputBankAccountType />
        <ButtonPrimary isLoading={isLoading}>
          Add Bank Account
        </ButtonPrimary>
      </Form>
      <Button
        fullWidth
        variant="text"
        onClick={onDone}
        disabled={isLoading}
      >
        Back
      </Button>
    </Screen>
  );
};

export default AddBankAccount;
